<template>
  <div id="app">
    <Header v-show="this.$store.state.isFooterShow"/>
    <div
      id="under"
      v-show="this.$store.state.isFooterShow"
      :class=" (isFlagLiClass !== null && isFlagLiClass !== '') ? 'under' : 'underCopy' "
    ></div>
    <FrontHeader v-show="this.$store.state.isFrontHeaderShow"/>
    <div class="selectDive">
        <IndexSelect v-show="this.$store.state.isFrontHeaderShow && this.$store.state.isIndexSelectShow"/>
    </div>
    <router-view></router-view>
    <Footer v-show="this.$store.state.isFooterShow"/>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Header from './components/UserHeader.vue'
import Footer from './components/UserFooter.vue'
// 前台
import FrontHeader from './views/FrontHeader.vue'
import IndexSelect from './views/IndexSelect.vue'
export default {
    name: 'app',
    components: {
        Header,
        Footer,
        FrontHeader,
        IndexSelect
    },
    created () {
        let lang = 'zh-TW'
        if (localStorage.getItem('language') && localStorage.getItem('language') !== 'null') {
            this.$store.state.switchLanguage = localStorage.getItem('language')
            lang = localStorage.getItem('language')
        } else {
            localStorage.setItem('language', lang)
            this.$store.state.switchLanguage = localStorage.getItem('language')
        }
        this.$root.$i18n.locale = lang
    },
    computed: {
        isFlagLiClass () {
            // let isFlagLiClass = this.$store.state.isFlagLiClass
            return this.$store.state.isFlagLiClass
        },
        isFlagSpanClass () {
            return this.$store.state.isFlagSpanClass
        }
    },
    methods: {
        filterUserClickFn (attrArr, e) {
            let res = false
            attrArr.forEach((ele) => {
                e.getAttribute(ele) && (res = ele)
            })
            return res
        }
    },
    mounted () {
        let that = this
        document.querySelector('body').onclick = function (e) {
            var event = e || window.event // 浏览器兼容性
            let elem = event.target || event.srcElement
            let attrArr = ['inputDomClick', 'stateDomClick', 'typeDomClick', 'rolesDomClick', 'addProjectDomClick', 'authenticationRegion']
            let res = that.filterUserClickFn(attrArr, elem)
            // 点击没有下拉的地方 全局globalSelectControlState = false; 如果有下拉 全局globalSelectControlState = 这个下拉的属性值
            that.$store.commit('globalSelectControlFn', { key: 'globalSelectControlState', status: res })
        }
    }
}
/* eslint-disable vue/no-unused-components */
</script>

<style>
/* #app { */
/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
/* } */
* {
    text-decoration: none;
}
#app {
    background: #ffffff;
    /* width: 1440px; */
    width: 1280px;
    margin: 0 auto;
    position: relative;
    font-family: sans-serif!important;
}
.under {
    height: 120px;
    /* height: 60px; */
}
.underCopy {
    height: 60px;
}
.row {
    margin: 0;
}
.selectDive{
    /* width: 1440px; */
    width: 1280px;
    margin: auto;
    position: relative;
}
.el-input--mini .el-input__inner{
    line-height: 15px!important;
}
</style>
